<template>
    <div
        v-bind="$attrs"
        class="flex flex-col items-start gap-3 rounded-lg border border-valence-grey-200 bg-valence-grey-50 px-4 py-4"
        data-test-id="profile-link-create-profile-prompt">
        <div class="flex flex-col gap-1">
            <p class="body-semibold text-valence-grey-850 text-center">{{ heading }}</p>
            <p class="body-small text-valence-grey-600 leading-relaxed">
                {{ description }}
                <BaseButton theme="tertiary" size="sm" class="w-fit" data-test-id="collaboration-profile-explainer-btn" @click="handleExplainerClick">
                    What's a Collaboration Profile?
                </BaseButton>
            </p>
        </div>
        <BaseButton theme="primary" class="w-full bg-valence-grey-850" @click="emit('cta-click')"> Create profile </BaseButton>
    </div>

    <DemoModal v-model:open="isArcadeOpen" :demo-url="COLLAB_PROFILE_DEMO_URL" header-text="What's a Collaboration Profile?" />
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import DemoModal from "~vue/components/DemoModal.vue";
import { computed, onMounted, ref } from "vue";

const props = defineProps<{
    lockedSuggestionCount: number;
    profileLinkSharingEnabled: boolean;
}>();

const emit = defineEmits<{
    shown: [];
    "cta-click": [];
    "explainer-click": [];
}>();

// With sharing disabled org-wide, don't promise a "share" capability that doesn't exist —
// this becomes a plain profile-completion nudge instead.
const heading = computed(() => {
    if (!props.profileLinkSharingEnabled) {
        return "Complete your Collaboration Profile";
    }
    return props.lockedSuggestionCount > 0
        ? `${props.lockedSuggestionCount} ${props.lockedSuggestionCount === 1 ? "suggestion" : "suggestions"} waiting to be shared`
        : "Share your profile with colleagues";
});

const description = computed(() =>
    props.profileLinkSharingEnabled
        ? "Create your Collaboration Profile so you can share it with your team and unlock these suggestions."
        : "Create your Collaboration Profile so Nadia can connect you with your team.",
);

onMounted(() => emit("shown"));

const COLLAB_PROFILE_DEMO_URL = "https://demo.arcade.software/uz3KgHLOvPgO6XsujHWv?embed&embed_mobile=tab&embed_desktop=inline&show_copy_link=true";
const isArcadeOpen = ref(false);

function handleExplainerClick() {
    isArcadeOpen.value = true;
    emit("explainer-click");
}
</script>
